exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  min-height: 100vh;\n  z-index: 999;\n  background-color: #000000cc;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  overflow-y: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/overlay/overlay.component.scss
// module id = ../../../../../src/app/ui-shared/overlay/overlay.component.scss
// module chunks = main